import React, { Component }  from 'react';
import { string, array, func, bool } from 'prop-types';

class SelectSearchable extends Component {

	constructor(props, context) {
		super(props, context);
		this.state = {

		};
		this.onChangeSelect = this.onChangeSelect.bind(this);
	}

	static propTypes = {
		onChange: func,
		options: array,
		selectedValue: string,
		className: string,
		id:string,
		clearable: bool,
		searchable: bool
	};

	onChangeSelect(newValue){
		this.props.onChange(newValue.value);
	}

	render() {
		return (

			<div>Retired component	{/*<Select*/}
				{/*value={props.selectedValue}*/}
				{/*id={props.id}*/}
				{/*className={`cp-select-searchable ${props.className}`}*/}
				{/*onChange={this.onChangeSelect}*/}
				{/*options={props.options}*/}
				{/*searchable={props.searchable}*/}
				{/*clearable={props.clearable}*/}
				{/*>*/}
				{/*</Select>*/}</div>
		);
	}
}


export default SelectSearchable;


// WEBPACK FOOTER //
// ./src/views/components/generic/select_searchable/SelectSearchable.jsx